import { useIntl } from '@capsicum/common';

export const useNCRegistration = () => {
	const { $t } = useIntl();

	const texts = {
		buttonContinue: $t('global.button.continue'),
		mainText: $t('ncOnboarding.registration.mainText'),
		title: $t('ncOnboarding.registration.title')
	};

	return {
		texts
	};
};
